/**
 * @generated SignedSource<<6e59cebb4eacd0fbb392c541a0954274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminSearchesQuery$variables = {};
export type AdminSearchesQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminSearches_viewer">;
  } | null;
};
export type AdminSearchesQuery = {
  response: AdminSearchesQuery$data;
  variables: AdminSearchesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "filters",
  "value": {}
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v2 = {
  "kind": "Literal",
  "name": "section",
  "value": "ADMIN"
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "direction": "DESC",
        "field": "CREATE_DATE"
      }
    ]
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = [
  "filters"
],
v16 = {
  "kind": "Literal",
  "name": "order",
  "value": [
    {
      "direction": "ASC",
      "field": "NAME"
    }
  ]
},
v17 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v16/*: any*/)
],
v18 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "direction": "ASC",
        "field": "USERNAME"
      }
    ]
  },
  (v2/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v20 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v16/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminSearchesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AdminSearches_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AdminSearchesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SaveSearchNodeConnection",
            "kind": "LinkedField",
            "name": "savedsearches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SaveSearchNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegacyUserNode",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobResponse",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitleId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobLabel",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewRegionNode",
                        "kind": "LinkedField",
                        "name": "region",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rateType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CurrencyNode",
                        "kind": "LinkedField",
                        "name": "currency",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "symbol",
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketRateNode",
                        "kind": "LinkedField",
                        "name": "marketRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "payRate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billRate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPct",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagNode",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tagId",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDraft",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGlobalSupplierSearch",
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "savedsearches(filters:{},first:10,order:[{\"direction\":\"DESC\",\"field\":\"CREATE_DATE\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "filters": (v15/*: any*/),
            "handle": "connection",
            "key": "AdminSearches_savedsearches",
            "kind": "LinkedHandle",
            "name": "savedsearches"
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "ClientTypeNodeConnection",
            "kind": "LinkedField",
            "name": "allClients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientId",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allClients(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}])"
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "filters": (v15/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortClients_allClients",
            "kind": "LinkedHandle",
            "name": "allClients"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "AuthorNodeConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": "authors(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"USERNAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "filters": (v15/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortCreatedBy_authors",
            "kind": "LinkedHandle",
            "name": "authors"
          },
          {
            "alias": null,
            "args": (v20/*: any*/),
            "concreteType": "TagNodeConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TagNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": "tags(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v20/*: any*/),
            "filters": (v15/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortTags_tags",
            "kind": "LinkedHandle",
            "name": "tags"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8d535b6909b055e7b961f8615ecec38",
    "id": null,
    "metadata": {},
    "name": "AdminSearchesQuery",
    "operationKind": "query",
    "text": "query AdminSearchesQuery {\n  viewer {\n    ...AdminSearches_viewer\n  }\n}\n\nfragment AdminSearchesSearch_search on SaveSearchNode {\n  id\n  searchId\n  createdDate\n  createdBy {\n    userId\n    username\n    firstName\n    lastName\n  }\n  job {\n    id\n    jobTitleId\n    jobTitle\n    jobLabel\n  }\n  city\n  state\n  country\n  region {\n    name\n    id\n  }\n  rateType\n  currency {\n    symbol\n    id\n  }\n  marketRate {\n    payRate\n    billRate\n    markupPct\n  }\n  tags {\n    tagId\n    name\n    id\n  }\n  isDraft\n  isGlobalSupplierSearch\n}\n\nfragment AdminSearches_viewer on Viewer {\n  savedsearches(first: 10, filters: {}, order: [{field: CREATE_DATE, direction: DESC}], section: ADMIN) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        searchId\n        ...AdminSearchesSearch_search\n        __typename\n      }\n    }\n  }\n  ...FilterAndSortClients_viewer\n  ...FilterAndSortCreatedBy2_viewer\n  ...FilterAndSortTags_viewer\n}\n\nfragment FilterAndSortClients_viewer on Viewer {\n  allClients(first: 10, filters: {}, order: [{direction: ASC, field: NAME}]) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        clientId\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment FilterAndSortCreatedBy2_viewer on Viewer {\n  authors(first: 10, filters: {}, order: [{direction: ASC, field: USERNAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        userId\n        firstName\n        lastName\n        username\n        email\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FilterAndSortTags_viewer on Viewer {\n  tags(first: 10, filters: {}, order: [{direction: ASC, field: NAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc5bb78cfb52e4d1b1cf0c707b29e539";

export default node;
